import { selectFeatureFlags } from 'core/userContext';
import {
  CAMPAIGN_EDITOR_FORM_FIELDS,
  NO_PROJECT_ALERTS_TOOLTIP_CONTENT,
} from 'modules/campaigns/editor/constants';
import { getShouldShowPerformanceAlerts } from 'modules/campaigns/editor/utils';
import { EnabledAlertsList } from 'modules/campaigns/lib/components/EnabledAlertsList';
import { useWatch } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { useCampaignAlertsContext, useCampaignContext, useEditorContext } from '../../../context';
import { CampaignFormField, ReadOnlyField } from '../../FormFields';
import { LightText, SectionHeader, SectionWrapper } from '../Sections.styled';
import { EditableAlerts } from './EditableAlerts';

export const EMBEDDED_OPTIMIZE_SECTION_TEST_ID = 'embedded-optimize-section';

export const EmbeddedDeliverySection = () => {
  const { campaignSteps } = useEditorContext();
  const { campaign } = useCampaignContext();
  const { alertDetails, hasProjectAlerts } = useCampaignAlertsContext();

  const [campaignAlertsEnabled] = useWatch({
    name: [CAMPAIGN_EDITOR_FORM_FIELDS.CAMPAIGN_ALERTS_ENABLED],
  });

  const isEditable = campaignSteps?.Delivery?.isEditable;

  const campaignType = campaign?.campaignTypeDefinition;
  const isJourneyAssociated = campaign?.isJourneyAssociated;

  const {
    CampaignPerformanceAlerts: isCampaignPerformanceAlertsEnabled,
    JourneysCampaignPerformanceAlerts: isJourneysCampaignPerformanceAlertsEnabled,
  } = useSelector(selectFeatureFlags);

  /** We only want to show the feature below if the respective flag is on. */
  const showPerformanceAlerts = getShouldShowPerformanceAlerts({
    campaignType,
    isCampaignPerformanceAlertsEnabled,
    isJourneysCampaignPerformanceAlertsEnabled,
    isJourneyAssociated,
  });

  const isAlertsToggleDisabled = !hasProjectAlerts;
  const hasDeliverySettings = showPerformanceAlerts;

  /** If no optimizations are available, then don't show anything */
  if (!hasDeliverySettings) {
    return <></>;
  }

  return (
    <SectionWrapper data-test={EMBEDDED_OPTIMIZE_SECTION_TEST_ID}>
      <SectionHeader>Optimize</SectionHeader>
      {showPerformanceAlerts && (
        <CampaignFormField labelText="Alerts" $removeMarginBottom>
          {isEditable ? (
            <EditableAlerts
              isDisabled={isAlertsToggleDisabled}
              tooltipContent={NO_PROJECT_ALERTS_TOOLTIP_CONTENT}
            />
          ) : (
            <ReadOnlyField name={CAMPAIGN_EDITOR_FORM_FIELDS.CAMPAIGN_ALERTS_ENABLED}>
              {campaignAlertsEnabled ? (
                <EnabledAlertsList alertDetails={alertDetails} defaultValue={<p>On</p>} />
              ) : (
                <LightText>Off</LightText>
              )}
            </ReadOnlyField>
          )}
        </CampaignFormField>
      )}
    </SectionWrapper>
  );
};
